<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div class="min-h-screen">
      <CommonSupport class="md:flex hidden" />
      <div class="w-full bg-[#F0FBFB] mt-3">
        <div class="-mt-4 md:mt-0">
          <div class="md:mt-5 relative flex flex-col md:flex-row w-full">
            <div
              class="tests-image w-full md:w-7/12 h-[200px] sm:h-[400px] bg-cover"
              alt=""
              :style="{
                backgroundImage: 'url(' + JSON.stringify(category.hero_banner.permalink) + ')',
              }"
            />
            <div class="-mt-10 md:mt-20 mx-4 lg:mt-0">
              <div class="space-y-6 md:space-y-10 flex flex-col md:mt-44 md:-ml-48">
                <div class="bg-white flex rounded-lg shadow-lg p-6 md:px-10">
                  <div class="flex items-start md:mt-5 mt-3">
                    <NuxtImg
                      loading="lazy"
                      :src="category.slug == 'health-and-wellness' ? '/icons/heartbeat.svg' : '/icons/woman-man.svg'"
                      alt="gender icon"
                      class="w-16 h-12"
                    />
                  </div>
                  <div class="flex flex-col md:px-6">
                    <h1 class="md:text-4xl text-[30px] mb-5 px-6 md:px-0 font-semibold text-start leading-9">
                      {{ $t(categoryTitleKey, { category: category.title }) }}
                    </h1>
                    <div class="flex w-full md:base-1/2">
                      <BaseButton
                        class="text-sm font-normal px-8 bg-white h-[30px] mb-4"
                        variant="outlined"
                        :text="
                          $t(categorySubTitleKey, {
                            category: category.title,
                          })
                        "
                        @click="scrollToView"
                      >
                        <NuxtImg class="w-2" src="/icons/arrow-down.svg"></NuxtImg>
                      </BaseButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <NuxtLayout name="center" class="flex flex-col md:flex-row justify-between">
            <div
              v-if="category.precautions.length > 0"
              class="w-full md:max-w-[326px] bg-[#A3DDE043] flex flex-col items-start px-4 pb-8 my-8 rounded-[4px]"
            >
              <h1 class="text-[14px] text-primary font-bold ml-5 uppercase">
                {{ $t("tests.considerTakingATest") }}
              </h1>
              <div class="flex flex-col space-y-6">
                <div
                  class="flex items-start space-x-3 text-base md:text-sm"
                  v-for="item in category.precautions"
                  :key="item.id"
                >
                  <NuxtImg loading="lazy" src="/icons/arrow-right.svg" alt="right arrow icon" class="w-3 mt-1.5" />
                  <span class="w-full">{{ item.title }}</span>
                </div>
              </div>
            </div>

            <div class="md:w-3/4 w-full md:p-6 my-6 space-y-6" v-if="bodyText && bodyText.length > 0">
              <div :key="content" class="md:ml-8 lg:ml-16" v-for="content in bodyText">
                <div class="text-[18px] font-semibold" v-html="content" />
              </div>
              <div class="md:ml-16">
                <NuxtLinkLocale
                  :locale="switchBlogLocale()"
                  @click="openServiceModal()"
                  class="text-secondary underline cursor-pointer text-[18px]"
                >
                  {{ $t("tests.cardLink") }}
                </NuxtLinkLocale>
              </div>
            </div>
          </NuxtLayout>
        </div>
      </div>

      <!-- How It Works Modal  -->
      <ProductInfoServiceModal
        :is-open="openModal"
        @on-modal-close="closeServiceModal"
        :default-service="defaultService"
      />

      <!-- FILTER SIDE BAR  -->
      <div v-if="filterSideBarOpen">
        <ProductMobileFilterSideBar
          :is-visible="filterSideBarOpen"
          :filters="contentFilters"
          @on-side-bar-close="closeFilterSideBar"
          :results-number="filtredProducts.length"
        />
      </div>
      <NuxtLayout name="center" id="tests" class="flex min-h-screen relative mt-10 md:mt-2 lg:py-10">
        <!-- FILTER SIDEBAR OPTIONS  -->
        <NuxtLayout name="side-filters">
          <ProductFilterSidebar
            v-if="!filterSideBarOpen"
            :contentFilters="contentFilters"
            isActive
          ></ProductFilterSidebar>
          <div class="mt-20">
            <CommonLiveChatBlock mobile />
          </div>
        </NuxtLayout>
        <div class="w-full lg:ml-10 bg-white container">
          <div class="flex flex-col md:flex-row justify-between md:items-center">
            <ClientOnly>
              <span>{{ $t("tests.showing") }} {{ filtredProducts.length }} {{ $t("common.results") }}</span>
            </ClientOnly>
            <div class="flex items-center space-x-4">
              <FilterFloatButton
                @clicked="openFilterSideBar()"
                v-if="isVisible && !isCtaBlockVisible"
                :selectedFilters="selectedFilters"
              ></FilterFloatButton>

              <div class="relative">
                <BaseVSearchTextInput
                  id="search-product"
                  name="search-product"
                  :label="`${$t('filter.searchText')}`"
                  v-model="productSearch"
                />
                <button
                  class="flex justify-center items-center bg-secondary text-white w-8 h-8 rounded-md absolute right-1 top-5 md:top-1 z-10"
                >
                  <SearchIcon class="w-6 h-6" />
                </button>
              </div>
              <div class="relative hidden lg:flex">
                <BaseSelect :value="sortOptionSelected" :options="sortOptions" class="w-52" @onClick="setSortOption" />
              </div>
            </div>
          </div>
          <div ref="target" class="-mx-4">
            <ProductList :categoryParams="categoryParams"></ProductList>
          </div>
        </div>
      </NuxtLayout>
      <div class="w-full bg-stone-white mb-16" v-if="contentFilters.categories.length > 0 && !serviceType">
        <NuxtLayout name="center">
          <ProductSubCategory :subTitle="`${$t('filter.catSubTitle')}`" :parentCategory="category"></ProductSubCategory>
        </NuxtLayout>
      </div>
      <CTABlock imgSrc="USPs_graphic_03_1" get-started ref="ctaBlock" />
    </div>
  </div>
</template>
<script setup>
import { useProductStore } from "@/stores/filter";
import { SearchIcon } from "@heroicons/vue/outline";
import CTABlock from "~~/components/clinic/CTABlock.vue";

const route = useRoute();
const filterStore = useProductStore();

const currentCategory = route.params.id;
const category = ref({});
const bodyText = ref([]);
const target = ref(null);
const ctaBlock = ref(null);
const categoryParams = ref({});
const { isCtaBlockVisible, isVisible } = useCheckVisibility(target, ctaBlock);
category.value = await useFetchCategoryDetails(currentCategory);
const contentFilters = ref([]);
const filterSideBarOpen = ref(false);
const defaultService = computed(() => {
  const queryServices = route.query.services;
  if (queryServices) {
    const slug = Array.isArray(queryServices) ? queryServices[0] : queryServices.split(",")[0];
    if (slug) {
      return { slug };
    }
  }
  return category.value?.service_type;
});

const serviceType = computed(() => {
  return category.value?.service_type?.slug;
});

const isHomeTestsCategory = computed(() => {
  const slug = category.value?.slug ?? "";
  return slug === "home-tests" || slug === "home_test";
});

const categoryTitleKey = computed(() =>
  isHomeTestsCategory.value ? "tests.category.titleNoSuffix" : "tests.category.title"
);
const categorySubTitleKey = computed(() =>
  isHomeTestsCategory.value ? "tests.category.subTitleNoSuffix" : "tests.category.subTitle"
);

if (serviceType.value) {
  categoryParams.value = { "service_type[0]": serviceType.value };
} else {
  categoryParams.value = { "categories[0]": category.value.id };
}
contentFilters.value = await useFilterOptions(categoryParams.value);
filterStore.getFilterOptions(contentFilters.value.min_price, contentFilters.value.max_price);

function parseQueryList(value) {
  if (!value) return [];
  const raw = Array.isArray(value) ? value : [value];
  return raw
    .flatMap((item) => String(item).split(","))
    .map((item) => item.trim())
    .filter(Boolean);
}

function handleRouteCategoryFilter(to, from) {
  if (to.query.categories === from?.query?.categories) return;
  if (!to.query.categories) return;

  const filterCategories = contentFilters.value?.categories;
  if (!Array.isArray(filterCategories)) return;

  parseQueryList(to.query.categories).forEach((slug) => {
    const entity = filterCategories.find((y) => y.slug === slug);
    if (!entity) return;

    filterStore.setCategory(entity);
    filterStore.addChecked(entity.slug);
  });
}

/**
 * @query services - comma separated services slugs
 * @param to - The current route object.
 * @param from - The previous route object.
 */
function handleRouteServiceFilter(to, from) {
  if (to.query.services === from?.query?.services || !to.query.services) return;

  const filterServices = contentFilters.value?.service_types;
  if (!Array.isArray(filterServices)) return;

  parseQueryList(to.query.services).forEach((slug) => {
    const entity = filterServices.find((y) => y.slug === slug);
    if (!entity) return;

    filterStore.setMultipleServices(entity);
    filterStore.addChecked(entity.slug);
  });
}

watch(
  route,
  (to, from) => {
    handleRouteCategoryFilter(to, from);
    handleRouteServiceFilter(to, from);
  },
  {
    immediate: true,
  }
);

watch(filterStore, ({ category: categories, checked }) => {
  if (import.meta.server) return;

  const path = trimLocaleFromPathname(route.path);
  const excludedPaths = ["/tests/health-and-wellness", "/tests/sexual-health"];

  if (excludedPaths.some((p) => path.startsWith(p))) {
    return;
  }

  if (checked.length > 0) {
    const entities = checked.map((x) => categories.find((y) => y.slug === x)?.slug).filter((x) => !!x);
    const nextCategories = entities.length > 0 ? entities.join(",") : undefined;

    if (route.query.categories === nextCategories) return;

    navigateTo({
      query: {
        ...route.query,
        categories: nextCategories,
      },
    });
  }
});

onBeforeRouteLeave(() => {
  filterStore.clearAllFilters();
});

onMounted(() => {
  //filterStore.clearAllFilters()
  filterStore.setSortOption(2);
  const regex = /<p>(.*?)<\/p>/g;
  bodyText.value = category.value.body_text.match(regex);
  selectedFiltersArray();
});

const selectedFilters = computed({
  get() {
    return filterStore.getCheckedFilter;
  },
});

const sortOptions = computed(() => filterStore.getSortOptions);
const sortOptionSelected = computed(() => filterStore.selectedSortOption);
const productSearch = computed({
  get() {
    if (filterStore.search == "") {
      filterStore.setSortOption(2);
    } else {
      filterStore.setSortOption(0);
    }
    return filterStore.search;
  },
  set(val) {
    filterStore.setSearchValue(val);
  },
});

const filtredProducts = computed(() => filterStore.filtredTests);

const setSortOption = (item) => {
  filterStore.setSortOptionMobile(item);
};

const openFilterSideBar = () => {
  document.body.classList.toggle("overflow-hidden");
  filterSideBarOpen.value = true;
};
const closeFilterSideBar = () => {
  document.body.classList.toggle("overflow-hidden");
  filterSideBarOpen.value = false;
};

const selectedFiltersArray = () => {
  return filterStore.checked;
};

const scrollToView = (e) => {
  e.preventDefault();
  // Scroll to a certain element
  document.getElementById("tests")?.scrollIntoView({
    behavior: "smooth",
  });
};

const openModal = ref(false);

const openServiceModal = () => {
  openModal.value = true;
};
const closeServiceModal = () => {
  openModal.value = false;
};

useMetaTitles(category.value, "test-category");

const breadcrumbs = getBreadcrumbs("test-category", category.value);
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

.target1 {
  border: 2px dashed;
  padding: 10px;
  max-height: 150px;
  margin: 0 2rem 400px;
}
</style>
